export const nav = {
home: 'Inicio',
about: 'Acerca de',
leadership: 'Liderazgo',
vision: 'Visi\u00f3n y Misi\u00f3n',
products: 'Productos',
business_model: 'Modelo de Negocio',
operations: 'Operaciones',
structure: 'Estructura',
compliance: 'Cumplimiento',
contact: 'Contacto',
privacy: 'Pol\u00edtica de Privacidad',
terms: 'T\u00e9rminos de Servicio',
cookies: 'Pol\u00edtica de Cookies',
};
